import React from 'react';
import { Link } from 'react-router-dom';
import { Trophy, Calendar, MapPin, ArrowRight, Award, Star } from 'lucide-react';

const Awards = () => {
  return (
    <div style={{ backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      {/* Hero Section */}
      <section className="hero-section text-center" style={{ 
        background: 'linear-gradient(135deg, rgba(255, 215, 0, 0.9), rgba(255, 165, 0, 0.9)), url("https://images.unsplash.com/photo-1567427017947-545c5f8d16ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80")',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
        <div className="container-custom">
          <h1 className="heading-1 text-white mb-6">Awards & Recognition</h1>
          <p className="body-large text-white mb-8" style={{ maxWidth: '600px', margin: '0 auto 2rem', opacity: 0.95 }}>
            Celebrating excellence in education, research, and innovation worldwide
          </p>
        </div>
      </section>

      <div className="container-custom" style={{ padding: '80px 24px' }}>
        {/* Awards Categories */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', 
          gap: '40px',
          marginBottom: '80px'
        }}>
          {/* Past Awards */}
          <Link to="/awards/past" style={{ textDecoration: 'none' }}>
            <div style={{ 
              background: 'linear-gradient(135deg, #ffd700 0%, #ffb347 100%)', 
              padding: '3px', 
              borderRadius: '20px', 
              boxShadow: '0 8px 32px rgba(255, 215, 0, 0.3)',
              transition: 'transform 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
              <div style={{ 
                backgroundColor: 'white', 
                padding: '50px', 
                borderRadius: '17px',
                textAlign: 'center'
              }}>
                <div style={{ 
                  width: '100px', 
                  height: '100px', 
                  background: 'linear-gradient(135deg, #ffd700 0%, #ffb347 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 30px',
                  fontSize: '3rem'
                }}>
                  🏆
                </div>
                <h3 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '20px' }}>
                  Past Awards
                </h3>
                <p style={{ color: '#718096', fontSize: '1.1rem', lineHeight: '1.6' }}>
                  Explore our prestigious awards and recognition ceremonies from previous years, celebrating excellence in education and research.
                </p>
                <div style={{ 
                  marginTop: '30px',
                  padding: '15px 30px',
                  background: 'linear-gradient(135deg, #ffd700 0%, #ffb347 100%)',
                  color: 'white',
                  borderRadius: '25px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontWeight: 600
                }}>
                  View Awards <ArrowRight size={20} />
                </div>
              </div>
            </div>
          </Link>

          {/* Upcoming Awards */}
          <Link to="/awards/upcoming" style={{ textDecoration: 'none' }}>
            <div style={{ 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
              padding: '3px', 
              borderRadius: '20px', 
              boxShadow: '0 8px 32px rgba(102, 126, 234, 0.3)',
              transition: 'transform 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-8px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
              <div style={{ 
                backgroundColor: 'white', 
                padding: '50px', 
                borderRadius: '17px',
                textAlign: 'center'
              }}>
                <div style={{ 
                  width: '100px', 
                  height: '100px', 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 30px',
                  fontSize: '3rem'
                }}>
                  ⭐
                </div>
                <h3 style={{ color: '#2d3748', fontSize: '2rem', fontWeight: 700, marginBottom: '20px' }}>
                  Upcoming Awards
                </h3>
                <p style={{ color: '#718096', fontSize: '1.1rem', lineHeight: '1.6' }}>
                  Discover upcoming award opportunities and nomination processes for excellence in education and research achievements.
                </p>
                <div style={{ 
                  marginTop: '30px',
                  padding: '15px 30px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  borderRadius: '25px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontWeight: 600
                }}>
                  View Opportunities <ArrowRight size={20} />
                </div>
              </div>
            </div>
          </Link>
        </div>

        {/* Awards Impact */}
        <div style={{ 
          background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)', 
          padding: '3px', 
          borderRadius: '20px', 
          boxShadow: '0 8px 32px rgba(255, 154, 158, 0.3)' 
        }}>
          <div style={{ 
            backgroundColor: 'white', 
            padding: '60px', 
            borderRadius: '17px'
          }}>
            <h2 style={{ textAlign: 'center', marginBottom: '50px', color: '#2d3748', fontSize: '2.5rem', fontWeight: 700 }}>
              Awards Impact
            </h2>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: '40px',
              textAlign: 'center'
            }}>
              <div>
                <div style={{ 
                  width: '80px', 
                  height: '80px', 
                  background: 'linear-gradient(135deg, #ffd700 0%, #ffb347 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '2rem'
                }}>
                  🏆
                </div>
                <div style={{ fontSize: '3rem', fontWeight: 700, color: '#ffd700', marginBottom: '10px' }}>
                  50+
                </div>
                <p style={{ color: '#718096', fontSize: '1.1rem', fontWeight: 600 }}>Awards Given</p>
              </div>
              
              <div>
                <div style={{ 
                  width: '80px', 
                  height: '80px', 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '2rem'
                }}>
                  👥
                </div>
                <div style={{ fontSize: '3rem', fontWeight: 700, color: '#667eea', marginBottom: '10px' }}>
                  200+
                </div>
                <p style={{ color: '#718096', fontSize: '1.1rem', fontWeight: 600 }}>Recipients</p>
              </div>
              
              <div>
                <div style={{ 
                  width: '80px', 
                  height: '80px', 
                  background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '2rem'
                }}>
                  🌍
                </div>
                <div style={{ fontSize: '3rem', fontWeight: 700, color: '#ff9a9e', marginBottom: '10px' }}>
                  15+
                </div>
                <p style={{ color: '#718096', fontSize: '1.1rem', fontWeight: 600 }}>Countries</p>
              </div>
              
              <div>
                <div style={{ 
                  width: '80px', 
                  height: '80px', 
                  background: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)', 
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px',
                  fontSize: '2rem'
                }}>
                  📅
                </div>
                <div style={{ fontSize: '3rem', fontWeight: 700, color: '#38b2ac', marginBottom: '10px' }}>
                  4
                </div>
                <p style={{ color: '#718096', fontSize: '1.1rem', fontWeight: 600 }}>Years Running</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Awards;